import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { Sparkles, ArrowRight } from 'lucide-react';
import Navbar from './components/Navbar';
import Services from './components/Services';
import About from './components/About';
import Contact from './components/Contact';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import QRMandaPage from './components/QRMandaPage';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [index, setIndex] = useState(0);
  const words = ["tu Negocio", "tu Visión", "tu Futuro", "tus Ideas"];

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentPage]);

  const whatsappNumber = "525624480446";
  const defaultMessage = encodeURIComponent("Hola, me gustaría más información sobre sus servicios de software.");
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${defaultMessage}`;

  return (
    <div className="App" id="inicio">
      <Navbar currentPage={currentPage} onNavigate={setCurrentPage} />
      
      {currentPage === 'home' ? (
        <main>
          <header className="hero-section">
            <div className="hero-glow-1"></div>
            <div className="hero-glow-2"></div>
            
            <motion.div 
              className="hero-content"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <button 
                type="button" 
                onClick={() => setCurrentPage('qrmanda')}
                className="hero-product-pill"
                style={{ cursor: 'pointer', border: '1px solid rgba(0, 210, 255, 0.4)', background: 'rgba(0, 210, 255, 0.08)' }}
              >
                <span className="pill-sparkle"><Sparkles size={13} /></span>
                <span className="pill-text"><strong>QRManda:</strong> Conoce nuestro software para restaurantes</span>
                <ArrowRight size={14} className="pill-arrow" />
              </button>
              
              <h1 className="hero-title">
                Arquitecturas Digitales que <br />
                escalan <br className="mobile-break" />
                <AnimatePresence mode="wait">
                  <motion.span
                    key={words[index]}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.5 }}
                    className="typewriter-text"
                  >
                    {words[index]}
                  </motion.span>
                </AnimatePresence>
              </h1>

              <p className="hero-subtitle">
                Diseñamos soluciones de software de alto impacto y ecosistemas web robustos. 
                Convertimos la complejidad técnica en una ventaja competitiva para tu empresa.
              </p>
              
              <div className="hero-actions">
                <a href="#contacto" className="cta-button primary">Iniciar Proyecto</a>
                <a href="#servicios" className="cta-button secondary">Explorar Capacidades</a>
              </div>
            </motion.div>

            <motion.div 
              className="scroll-indicator"
              animate={{ y: [0, 10, 0] }}
              transition={{ repeat: Infinity, duration: 2 }}
            >
              <div className="mouse"></div>
            </motion.div>
          </header>

          <Services />
          <About />
          <Contact />
          <FAQSection />
        </main>
      ) : (
        <main>
          <QRMandaPage whatsappNumber={whatsappNumber} />
        </main>
      )}

      <Footer />

      <motion.a 
        href={whatsappLink} 
        className="whatsapp-float-btn"
        target="_blank" 
        rel="noopener noreferrer"
        aria-label="Contactar por WhatsApp"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1, type: "spring", stiffness: 260, damping: 20 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        <FontAwesomeIcon icon={faWhatsapp} className="whatsapp-icon" />
        <span className="whatsapp-tooltip">¿Hablamos por WhatsApp?</span>
      </motion.a>
    </div>
  );
}

export default App;